import React from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import WelcomeCard from './WelcomeCard';
import WelcomeMoreInfoTip from './WelcomeMoreInfoTip';

type Props = {
  variant: 'admin' | 'staff';
  isNz?: boolean;
  children?: ReactNode;
};

const WelcomeFooterTip: FunctionComponent<Props> = ({ variant, isNz, children }) => (
  <WelcomeCard variant={variant}>
    <div className={'rounded-xl bg-gray-100 px-6 py-5'}>
      {children}
      <div className={children ? 'mt-4' : undefined}>
        <WelcomeMoreInfoTip
          isNz={isNz}
          owlClassName={'w-14 h-16 md:w-11 md:h-14'}
          textClassName={'text-gray-800'}
          mutedClassName={'text-gray-800'}
        />
      </div>
    </div>
  </WelcomeCard>
);

export default WelcomeFooterTip;
